export default "__VITE_PUBLIC_ASSET__5a31ab93__"